import { apiClient, buildApiUrl } from "../../../services/apiClient";
import type { LanguageCode } from "../../../utils/language";
import { createSlug } from "../../../utils/slug";
import type { BlogDetail, BlogListResponse } from "../types";

export const getBlogList = async (
  language: LanguageCode
): Promise<BlogListResponse> => {
  const url = `${buildApiUrl("/get_bloglar")}?lang=${language}`;
  const response = await apiClient.post(
    url,
    {
      lang: language,
      blog_kategori_id: -1,
      start: 0,
      end: 999,
    },
    {
      headers: {
        "Accept-Language": language,
      },
    }
  );

  return response.data.data;
};

export const getBlogDetailBySlug = async (
  slug: string,
  language: LanguageCode
): Promise<BlogDetail> => {
  const listResponse = await getBlogList(language);
  const blog = listResponse.blog.find(
    (item) => createSlug(item.baslik, language) === slug
  );

  if (!blog) {
    throw new Error("BLOG_NOT_FOUND");
  }

  const url = `${buildApiUrl("/get_blog_detay")}?lang=${language}`;
  const response = await apiClient.post(
    url,
    {
      lang: language,
      blog_id: blog.blog_id,
    },
    {
      headers: {
        "Accept-Language": language,
      },
    }
  );

  return response.data.data;
};
